export const RUNNING_TIMES_WIDGET_NAMESPACE = 'widget.running-times'
